import { Link } from "react-router-dom";

import Text from "../../styleguide/Text";
import { isDevelop } from "../../helpers/apiHelper";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

function NavbarLogo({
  withEnvIndicator,
  style,
}: {
  withEnvIndicator?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div className="ml-2.5 flex h-full items-center" style={style}>
      <Link className="h-full text-inherit no-underline" to="/" tabIndex={-1}>
        <img
          height={50}
          width={50}
          src={toAbsoluteUrl("/logo.svg")}
          alt="img"
        />
      </Link>
      {withEnvIndicator && isDevelop && (
        <Text variant="h1" className="ml-3">
          Develop
        </Text>
      )}
    </div>
  );
}

export default NavbarLogo;
